import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appRemoveLeadingZeros]',
  standalone: false
})
export class RemoveLeadingZerosDirective {

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value;
    console.log("value"+value)
    if (value) {
      const cleaned = value.replace(/^0+/, '');
      if (cleaned !== value) {
        console.log("cleaned"+cleaned)
        this.control.control?.setValue(cleaned);
      }
    }
  }

}
